// product-media.js — StateDecal
// Thumbnail gallery switcher for PDP

(function () {
  'use strict';

  var mainImg = document.getElementById('product-main-image');
  var thumbs = document.querySelectorAll('.product__thumb');

  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.imageSrc;
      var alt = thumb.dataset.imageAlt;

      if (!src) return;

      mainImg.src = src;
      if (alt) mainImg.alt = alt;

      thumbs.forEach(function (t) { t.classList.remove('product__thumb--active'); });
      thumb.classList.add('product__thumb--active');
    });
  });
})();
